import { acaoDetalheSobDemanda, telaSobDemanda, type AcaoDetalhe, type TelaRotina } from '../tipoTelaRotina';

export const telasFAT: Record<string, TelaRotina> = {
  'fat/painel': telaSobDemanda(() => import('../../../modulos/FAT/PainelComercial'), 'PainelComercial'),
  'fat/reprocessamento': telaSobDemanda(() => import('../../../modulos/FAT/PaginaReprocessamento'), 'PaginaReprocessamento'),
  'fat/faturamento': telaSobDemanda(() => import('../../../modulos/FAT/PaginaFaturamento'), 'PaginaFaturamento'),
};

/** Ações extras no detalhe do registro (`acoesDetalheRotina`). */
export const acoesDetalheFAT: Record<string, AcaoDetalhe> = {
  FAT060: acaoDetalheSobDemanda(() => import('../../../modulos/FAT/PreviaFiscalDoPedido'), 'PreviaFiscalDoPedido'),
};
